import * as React from "react";
import NavBar from "../components/NavBar";
import { RouteChildrenProps } from "react-router";
import firebase from "../firebase";

export default class LogoutPage extends React.Component {
    async componentDidMount(): Promise<void> {
        // here logout code
        await firebase.auth().signOut();
        console.log("LogoutPage#componentWillMount");
        location.href = "/";
    }
    render() {
        return null;
    }
}
